import { Box, Button } from '@mui/material'
import { Note24Regular } from '@/components/Icon'
import styles from './ThreadListRow.module.scss'

export default function ThreadListRowTitleButton({ title, active, onClick, showNoteIcon }) {
  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick}
      aria-current={active ? 'true' : undefined}
      className={`${styles.threadRow} ${showNoteIcon ? styles.threadRowWithNote : ''}`}
    >
      {showNoteIcon ? (
        <Box component="span" className={styles.noteIcon} aria-hidden>
          <Note24Regular />
        </Box>
      ) : null}
      <Box component="span" className={styles.title}>
        {title}
      </Box>
    </Button>
  )
}
